import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
 import { useLanguage } from '../hooks/useLanguage';
import { SUPPORTED_LANGUAGES } from '../config/supportedLanguages';

// Define the type for supported language codes
type SupportedLanguageCode = keyof typeof SUPPORTED_LANGUAGES;

type LanguageContextType = {
  language: SupportedLanguageCode | string; // Allow string for backward compatibility
  changeLanguage: (lang: SupportedLanguageCode | string) => void;
  availableLanguages: typeof SUPPORTED_LANGUAGES;
  getLanguageUrl: (path: string, lang?: SupportedLanguageCode | string) => string;
};

const LanguageContext = createContext<LanguageContextType>({
  language: 'vi',
  changeLanguage: () => {},
  availableLanguages: SUPPORTED_LANGUAGES,
  getLanguageUrl: () => '',
});

type LanguageProviderProps = {
  children: ReactNode;
};

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const { changeLanguage: setLanguage, getCurrentLanguage, getAvailableLanguages } = useLanguage();
  const [language, setCurrentLanguage] = useState(getCurrentLanguage());
  
  // Initialize language from URL or localStorage
  // useEffect(() => {
  //   const updateLanguage = (newLang: string) => {
  //     if (i18n.language !== newLang) {
  //       i18n.changeLanguage(newLang);
  //     }
  //     setLanguage(newLang);
  //     setCurrentLanguage(newLang);
  //   };

  //   // Kiểm tra ngôn ngữ trong localStorage trước
  //   const savedLanguage = localStorage.getItem('language');
  //   if (savedLanguage && Object.keys(SUPPORTED_LANGUAGES).includes(savedLanguage)) {
  //     updateLanguage(savedLanguage);
  //     return;
  //   }

  //   // Nếu không có ngôn ngữ trong localStorage, kiểm tra URL params
  //   if (lang && Object.keys(SUPPORTED_LANGUAGES).includes(lang)) {
  //     updateLanguage(lang);
  //     return;
  //   }

  //   // Fallback về ngôn ngữ mặc định
  //   updateLanguage('vi');
  // }, [lang, i18n, setLanguage]);
  
  const handleChangeLanguage = (lang: string) => {
    setLanguage(lang);
    setCurrentLanguage(lang);
  };
  
  // Helper to get URL with language prefix
  const getLanguageUrl = (path: string, customLang?: SupportedLanguageCode | string) => {
    const langToUse = customLang || language;
    
    // Validate that language is supported
    const validLang = Object.keys(SUPPORTED_LANGUAGES).includes(langToUse) 
      ? langToUse 
      : 'vi';
    
    // Handle absolute paths
    // if (path.startsWith('/')) {
    //   return `#/${validLang}${path}`;
    // }
    // // Handle relative paths
    // return `#/${validLang}/${path}`;
    return ''
  };
  
  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage: handleChangeLanguage,
        availableLanguages: getAvailableLanguages(),
        getLanguageUrl,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
